import type { CarbonInjection } from "../models/eaf.models";

const INJECTION_TYPES_WITH_DOOR: ReadonlySet<CarbonInjection["Type"]> = new Set(
  ["O2-Comb", "Gas"],
);

export const hasInjectorDoor = (type: CarbonInjection["Type"]): boolean =>
  INJECTION_TYPES_WITH_DOOR.has(type);
